import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { dialogActions } from '../components/dialog/slice/dialog-slice';
import { localStorageActions } from '../slices/local-storage-slice';

/**
 * 完成画像入稿・レイアウト編集で共通の「色空間警告」ダイアログ本文を返す。
 * Exifに色空間情報が無い場合と、sRGB以外が指定されている場合で文言を出し分ける。
 */
export const getExifColorSpaceWarningMessage = (colorSpace: string | undefined): string[] => (
  !colorSpace
    ? [
      'Exifヘッダ情報に色空間の情報がありません。',
      '色空間がsRGBでない場合、色が変わる可能性があります。',
    ]
    : [
      'sRGB以外の色空間が指定されています。',
      '色空間がsRGBでない場合、色が変わる可能性があります。',
    ]
);

/**
 * 色空間警告ダイアログ（dialogActions.pushMessage 版）を表示する。
 * 「次回から表示しない」チェックで storage.isStopDialog.exifWarning（localStorage永続）を更新する。
 * 抑制(stopWarning)の判定は呼び出し側のガードに委ねる。
 */
export const pushExifColorSpaceWarningDialog = (dispatch: Dispatch<AnyAction>, colorSpace: string | undefined) => {
  dispatch(dialogActions.pushMessage({
    title: '確認',
    message: getExifColorSpaceWarningMessage(colorSpace),
    buttons: [{
      label: 'OK',
      callback: () => {
        dispatch(dialogActions.pop());
      },
    }],
    remind: {
      callback: (v: boolean) => dispatch(localStorageActions.setIsStopDialog({ key: 'exifWarning', value: v })),
    },
  }));
};
